import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { createPageViewEvent, referrerForPageView } from "../utils/pageView";
import { trackEvent } from "../utils/telemetry";

export function PageViewTracker() {
  const location = useLocation();
  const lastTrackedLocationKey = useRef<string | null>(null);
  // The previous in-site page (origin + path), null until the first view of this document has been
  // reported. See referrerForPageView for why document.referrer alone is wrong past the first view.
  const previousPageUrl = useRef<string | null>(null);

  useEffect(() => {
    // React StrictMode replays effects in development. A ref suppresses only that replay; returning
    // to an earlier history entry still counts because the immediately previous key is different.
    if (lastTrackedLocationKey.current === location.key) return;
    lastTrackedLocationKey.current = location.key;

    const referrer = referrerForPageView(previousPageUrl.current, document.referrer);
    previousPageUrl.current = `${window.location.origin}${location.pathname}`;

    const event = createPageViewEvent(location.pathname, document.documentElement.lang, referrer);
    if (event) {
      trackEvent(event);
    }
  }, [location.key, location.pathname]);

  return null;
}
